// ../utils.ts
var isBrowser = () => typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.navigator !== "undefined";
var IS_BROWSER = isBrowser();
var AGENT = IS_BROWSER ? navigator.userAgent : "";
var IS_ANDROID = /android/i.test(AGENT);
var IS_FIREFOX = /firefox/i.test(AGENT);
var _a;
IS_BROWSER && // @ts-expect-error Typescript has not implemented userAgentData yet https://stackoverflow.com/a/71392474
/^Mac/i.test(((_a = navigator.userAgentData) == null ? void 0 : _a.platform) || navigator.platform);
var attr = (el, name, value) => {
  if (value === void 0) return el.getAttribute(name);
  if (value === null) el.removeAttribute(name);
  else if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  return null;
};
var onMutation = (el, callback, options) => {
  const observer = new MutationObserver((records) => {
    if (!isBrowser() || !el.isConnected) return cleanup();
    callback(el, records);
  });
  const cleanup = Object.assign(() => observer.disconnect(), {
    takeRecords: () => observer.takeRecords()
    // Expose takeRecords - useful if mutating a attribute that is observed
  });
  callback(el);
  observer.observe(el, options);
  return cleanup;
};

// polyfill.ts
var KEY = "__uDetailsPolyfillSummarys";
if (isBrowser() && IS_ANDROID && IS_FIREFOX && !window[KEY]) {
  const summaries = document.getElementsByTagName("summary");
  const onMutations = () => {
    for (const summary of summaries) {
      const details = summary.parentElement;
      attr(summary, "role", "button");
      attr(summary, "aria-expanded", `${!!(details == null ? void 0 : details.open)}`);
    }
  };
  window[KEY] = onMutation(document, onMutations, {
    attributeFilter: ["open"],
    attributes: true,
    childList: true,
    subtree: true
  });
}
